<div class="table-header">
  <button nz-button nzType="primary" nzShape="round" (click)="showModal()">
    <nz-icon nzType="plus"></nz-icon>
    Nuevo
  </button>
</div>

<app-tabla
  [searchable]="true"
  [columns]="columns"
  [data]="listOfData"
  (edit)="onEdit($event)"
  (delete)="onDelete($event)"
  [showCheckButton]="false"
></app-tabla>
